import { OnboardingStepperSideMenu } from '../../_layout/OnboardingStepperSideMenu'

function CompanyConfirmationSideMenu() {
  return <OnboardingStepperSideMenu />
}

export { CompanyConfirmationSideMenu }
